import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.054 2.293a1 1 0 0 1 0 1.414l-1.35 1.35a1 1 0 1 1-1.415-1.414l1.35-1.35a1 1 0 0 1 1.415 0m8.389 1.83a8.04 8.04 0 0 0-5.956 14.548 1 1 0 1 1-1.131 1.649 10.04 10.04 0 0 1 7.436-18.165 1 1 0 1 1-.35 1.969m2.69-.2a1 1 0 0 1 1.384-.29 10.04 10.04 0 0 1-7.432 18.255 1 1 0 1 1 .385-1.962 8.04 8.04 0 0 0 5.952-14.619 1 1 0 0 1-.289-1.384m-2.912 4.048a1 1 0 1 0-2 0v4.44l-2.287.966a1 1 0 1 0 .778 1.842l2.897-1.223a1 1 0 0 0 .611-.92zm5.725-4.264a1 1 0 0 1 1.414-1.414l1.35 1.35a1 1 0 1 1-1.413 1.415z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: n };
export {
  i as default,
  n as render
};
//# sourceMappingURL=ic_timer-ChFtXTTs.js.map
